import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Icon from 'components/icon';

import './style.css';

const ProductCard = ({ product }) => {
  const { name, description, icon, pathname } = product;

  if (!product) return null;
  return (
    <NavLink to={pathname} className="c-product-card">
      <div className="product-icon"><Icon name={icon} /></div>
      <h3>{name}</h3>
      <p>{description}</p>
      <p className="product-link">Know more</p>
    </NavLink>
  );
};

ProductCard.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.node,
  }).isRequired,
};

export default ProductCard;



// WEBPACK FOOTER //
// ./src/components/product-card/index.js